module.exports = __webpack_public_path__ + "img/data.3f4ef708.svg";